import { GET_USER_PROFILE_URL, get_headers } from "@/utils/constants/constants.js";
import alert_mixin from "@/utils/mixins/alert_mixin";
import axios from "axios";

export default {
  name: "UserProfileComponent",
  mixins: [alert_mixin],
  data: () => ({
      user_details: null,
      edited_details: {},
      is_loading: true,
      is_editing: false,
      error_message: null,
      entity_profile_id: null,
      user_id: null,
      headers: get_headers(),
  }),
  props: {
    profile_id: {
      type: Number,
      required: false,
      default: null,
    },
    user_identifier: {
      type: Number,
      required: false,
      default: null,
    },
  },
  mounted() {
    this.fetch_user_details();
  },
  methods: {
    async fetch_user_details() {
      this.is_loading = true;
      this.error_message = null;

      try {
        const params = {};

        if (this.profile_id) {
          params.entity_profile_id = this.profile_id;
        } else if (this.user_identifier) {
          params.user_id = this.user_identifier;
        }

        const response = await axios.get(GET_USER_PROFILE_URL, {
          headers: this.headers,
          params: params,
        });

        if (response.data.status === "success") {
          this.user_details = response.data.data;
          this.edited_details = { ...this.user_details };
        } else {
          this.error_message = response.data.message || "Unable to retrieve user details";
        }
      } catch (error) {
        this.error_message = error.message || "An error occurred while fetching user details";
        this.error("Error fetching user details:", error);
      } finally {
        this.is_loading = false;
      }
    },
    start_editing() {
      this.is_editing = true;
      this.edited_details = { ...this.user_details };
    },
    cancel_editing() {
      this.is_editing = false;
      this.edited_details = { ...this.user_details };
    },
    save_changes() {
      // Add API call to save changes if needed
      this.user_details = { ...this.edited_details };
      this.is_editing = false;
      // TODO: Implement API call to persist changes
    },
    format_date(date_string) {
      if (!date_string) return "N/A";
      return new Date(date_string).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    get_status_class(is_active, is_blocked) {
      if (is_blocked) return "status_blocked";
      if (is_active) return "status_active";
      return "status_inactive";
    },
    get_verification_class(is_verified) {
      return is_verified ? "verified" : "unverified";
    },
    get_initials() {
      const first = this.user_details?.first_name?.charAt(0) || "";
      const last = this.user_details?.last_name?.charAt(0) || "";
      return (first + last).toUpperCase() || "U";
    },
  },
};